import AutoSuggestDeluxe from './AutoSuggestDeluxe';

export default AutoSuggestDeluxe;
